import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import("../pages/auth/loginView.vue"),
    },
    {
      path: "/receipt/:id",
      name: "Receipt",
      component: () => import("@/pages/orders/receipt.vue"),
      meta: { title: "Receipt" },
    },
    {
      path: "/prescription/:id",
      name: "Prescription",
      component: () => import("@/pages/orders/prescription.vue"),
      meta: { title: "Prescription" },
    },
    {
      path: "/success",
      name: "Payment Success",
      component: () => import("@/pages/orders/paymentSuccess.vue"),
      meta: { title: "Receipt" },
    },
    {
      path: "/failure",
      name: "Payment Failure",
      component: () => import("@/pages/orders/paymentFailure.vue"),
      meta: { title: "Payment Failure" },
    },
    {
      path: "/invoice/:id",
      name: "Invoice",
      component: () => import("@/pages/orders/invoiceV2.vue"),
      meta: { title: "Invoice", requiresAuth: true },
    },
    {
      path: "/dashboard",
      component: () => import("@/pages/Dashboard.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          name: "dashboard",
          component: () => import("@/pages/DashboardView.vue"),
          meta: { title: "Dashboard", requiresAuth: true },
        },
        {
          path: "my-points",
          name: "doctor-points-dashboard",
          component: () => import("@/pages/doctor-points/Dashboard.vue"),
          meta: { title: "My Points", requiresAuth: true },
        },
        {
          path: "researcher-points",
          name: "researcher-points-dashboard",
          component: () => import("@/pages/researcher-points/Dashboard.vue"),
          meta: { title: "Network Points", requiresAuth: true },
        },
        {
          path: "products",
          name: "products",
          component: () => import("@/pages/products/List.vue"),
          meta: { title: "Products", key: "product", requiresAuth: true },
        },
        {
          path: "add-product",
          name: "add-product",
          component: () => import("@/pages/products/Add.vue"),
          meta: { title: "Add Product", requiresAuth: true },
        },
        {
          path: "edit-product/:id",
          name: "edit-product",
          component: () => import("@/pages/products/Add.vue"),
          meta: { title: "Edit Product", requiresAuth: true },
        },
        {
          path: "view-product/:id",
          name: "view-product",
          component: () => import("@/pages/products/View.vue"),
          meta: { title: "View Product", requiresAuth: true },
        },
        {
          path: "categories",
          name: "categories",
          component: () => import("@/pages/categories/List.vue"),
          meta: { title: "categories", key: "category", requiresAuth: true },
        },
        {
          path: "add-category",
          name: "add-category",
          component: () => import("@/pages/categories/Add.vue"),
          meta: { title: "Add Category", requiresAuth: true },
        },
        {
          path: "edit-category/:id",
          name: "edit-category",
          component: () => import("@/pages/categories/Add.vue"),
          meta: { title: "Edit Category", requiresAuth: true },
        },
        {
          path: "view-category/:id",
          name: "view-category",
          component: () => import("@/pages/categories/View.vue"),
          meta: { title: "View Category", requiresAuth: true },
        },
        {
          path: "orders",
          name: "orders",
          component: () => import("@/pages/orders/List.vue"),
          meta: { title: "Orders", requiresAuth: true },
        },
        {
          path: "view-order/:id",
          name: "view-order",
          component: () => import("@/pages/orders/View.vue"),
          meta: { title: "Order Details", requiresAuth: true },
        },
        {
          path: "add-order",
          name: "add-order",
          component: () => import("@/pages/orders/Add.vue"),
          meta: { title: "Add Order", requiresAuth: true },
        },
        {
          path: "my-collections",
          name: "my-collections",
          component: () => import("@/pages/my-collections/List.vue"),
          meta: { title: "My Collections", requiresAuth: true },
        },
        {
          path: "customers",
          name: "customers",
          component: () => import("@/pages/customers/List.vue"),
          meta: { title: "Customers", key: "customer", requiresAuth: true },
        },
        {
          path: "add-customer",
          name: "add-customer",
          component: () => import("@/pages/customers/Add.vue"),
          meta: { title: "Add Customer", requiresAuth: true },
        },
        {
          path: "view-customer/:id",
          name: "view-customer",
          component: () => import("@/pages/customers/View.vue"),
          meta: { title: "View Customer", requiresAuth: true },
        },
        {
          path: "edit-customer/:id",
          name: "edit-customer",
          component: () => import("@/pages/customers/Edit.vue"),
          meta: { title: "Edit Customer", requiresAuth: true },
        },
        {
          path: "deliveries",
          name: "deliveries",
          component: () => import("@/pages/deliveries/List.vue"),
          meta: { title: "Deliveries", key: "delivery", requiresAuth: true },
        },
        {
          path: "add-delivery",
          name: "add-delivery",
          component: () => import("@/pages/deliveries/Add.vue"),
          meta: { title: "Add Delivery", requiresAuth: true },
        },
        {
          path: "view-delivery/:id",
          name: "view-delivery",
          component: () => import("@/pages/deliveries/View.vue"),
          meta: { title: "View Delivery", requiresAuth: true },
        },
        {
          path: "tickets",
          name: "tickets",
          component: () => import("@/pages/tickets/List.vue"),
          meta: { title: "Tickets", requiresAuth: true },
        },
        {
          path: "view-ticket/:id",
          name: "view-ticket",
          component: () => import("@/pages/tickets/View.vue"),
          meta: { title: "Ticket Details", requiresAuth: true },
        },
        {
          path: "notifications",
          name: "notifications",
          component: () => import("@/pages/notifications/List.vue"),
          meta: { title: "Push Notifications", requiresAuth: true },
        },
        {
          path: "add-notification",
          name: "add-notification",
          component: () => import("@/pages/notifications/Add.vue"),
          meta: { title: "Add Notification", requiresAuth: true },
        },
        {
          path: "edit-notification/:id",
          name: "edit-notification",
          component: () => import("@/pages/notifications/Add.vue"),
          meta: { title: "Edit Notification", requiresAuth: true },
        },
        {
          path: "view-notification/:id",
          name: "view-notification",
          component: () => import("@/pages/notifications/View.vue"),
          meta: { title: "Notification Details", requiresAuth: true },
        },
        {
          path: "inventory",
          name: "inventory",
          component: () => import("@/pages/inventory/List.vue"),
          meta: { title: "Inventory", requiresAuth: true },
        },
        {
          path: "settings",
          name: "settings",
          component: () => import("@/pages/setting/index.vue"),
          meta: { title: "Setting", requiresAuth: true },
        },
        {
          path: "add-roles",
          name: "add-roles",
          component: () => import("@/pages/setting/roles/Add.vue"),
          meta: { title: "Add Role", requiresAuth: true },
        },
        {
          path: "edit-roles/:id",
          name: "edit-roles",
          component: () => import("@/pages/setting/roles/Add.vue"),
          meta: { title: "Edit Role", requiresAuth: true },
        },
        {
          path: "view-roles/:id ",
          name: "view-roles",
          component: () => import("@/pages/setting/roles/View.vue"),
          meta: { title: "Role Details", requiresAuth: true },
        },
        {
          path: "add-users",
          name: "add-users",
          component: () => import("@/pages/customers/Add.vue"),
          meta: { title: "Add Doctor", requiresAuth: true },
        },
        {
          path: "edit-users/:id",
          name: "edit-users",
          component: () => import("@/pages/customers/Add.vue"),
          meta: { title: "Edit Doctor", requiresAuth: true },
        },
        {
          path: "view-users/:id",
          name: "view-users",
          component: () => import("@/pages/setting/users/View.vue"),
          meta: { title: "User Details", requiresAuth: true },
        },
        {
          path: "promotion-discounts",
          name: "promotion-discounts",
          component: () => import("@/pages/promotion-discounts/List.vue"),
          meta: {
            title: "Promotion",
            key: "promotion-discounts",
            requiresAuth: true,
          },
        },
        {
          path: "add-promotion-discounts",
          name: "add-promotion-discounts",
          component: () => import("@/pages/promotion-discounts/Add.vue"),
          meta: { title: "Add promotion", requiresAuth: true },
        },
        {
          path: "edit-promotion-discounts/:id",
          name: "edit-promotion-discounts",
          component: () => import("@/pages/promotion-discounts/Add.vue"),
          meta: { title: "Edit promotion", requiresAuth: true },
        },
        {
          path: "view-promotion-discounts/:id",
          name: "view-promotion-discounts",
          component: () => import("@/pages/promotion-discounts/View.vue"),
          meta: { title: "promotion Details", requiresAuth: true },
        },
        {
          path: "promotion-ads",
          name: "promotion-ads",
          component: () => import("@/pages/promotion-ads/List.vue"),
          meta: { title: "Promotion", key: "promotion-ad", requiresAuth: true },
        },
        {
          path: "add-promotion-ad",
          name: "add-promotion-ad",
          component: () => import("@/pages/promotion-ads/Add.vue"),
          meta: { title: "Add Ads", requiresAuth: true },
        },
        {
          path: "edit-promotion-ad/:id",
          name: "edit-promotion-ad",
          component: () => import("@/pages/promotion-ads/Add.vue"),
          meta: { title: "Edit Ads", requiresAuth: true },
        },
        {
          path: "view-promotion-ad/:id",
          name: "view-promotion-ad",
          component: () => import("@/pages/promotion-ads/View.vue"),
          meta: { title: "View AD", requiresAuth: true },
        },
        {
          path: "promotion-featured-products",
          name: "promotion-featured-products",
          component: () => import("@/pages/promotion-featured-products/List.vue"),
          meta: {
            title: "Promotion",
            key: "promotion-featured-product",
            requiresAuth: true,
          },
        },
        {
          path: "add-promotion-featured-product",
          name: "add-promotion-featured-product",
          component: () => import("@/pages/promotion-featured-products/Add.vue"),
          meta: { title: "Add Featured Product", requiresAuth: true },
        },
        {
          path: "edit-promotion-featured-product/:id",
          name: "edit-promotion-featured-product",
          component: () => import("@/pages/promotion-featured-products/Add.vue"),
          meta: { title: "Edit Featured Product", requiresAuth: true },
        },
        {
          path: "view-promotion-featured-product/:id",
          name: "view-promotion-featured-product",
          component: () => import("@/pages/promotion-featured-products/View.vue"),
          meta: { title: "Featured Product Details", requiresAuth: true },
        },
        {
          path: "knet-transactions",
          name: "knet-transactions",
          component: () => import("@/pages/knet-transactions/List.vue"),
          meta: { title: "Knet Transactions", requiresAuth: true },
        },
        {
          path: "permission-test",
          name: "permission-test",
          component: () => import("@/pages/PermissionTest.vue"),
          meta: { title: "Permission Test", requiresAuth: true },
        },
        {
          path: "permission-debug",
          name: "permission-debug",
          component: () => import("@/pages/PermissionDebug.vue"),
          meta: { title: "Permission Debug", requiresAuth: true },
        },
        {
          path: "dashboard-debug",
          name: "dashboard-debug",
          component: () => import("@/pages/DashboardDebug.vue"),
          meta: { title: "Dashboard Debug", requiresAuth: true },
        },
        {
          path: "dashboard-simple",
          name: "dashboard-simple",
          component: () => import("@/pages/DashboardSimple.vue"),
          meta: { title: "Dashboard Simple", requiresAuth: true },
        },
        {
          path: "dashboard-test",
          name: "dashboard-test",
          component: () => import("@/pages/DashboardTest.vue"),
          meta: { title: "Dashboard Test", requiresAuth: true },
        },
        {
          path: "dashboard-fallback",
          name: "dashboard-fallback",
          component: () => import("@/pages/DashboardFallback.vue"),
          meta: { title: "Dashboard Fallback", requiresAuth: true },
        },
        {
          path: "promotion-promo-code",
          name: "promotion-promo-code",
          component: () => import("@/pages/promotion-promo-code/List.vue"),
          meta: {
            title: "Promotion",
            key: "promotion-promo-code",
            requiresAuth: true,
          },
        },
        {
          path: "locations",
          name: "locations",
          component: () => import("@/pages/locations/List.vue"),
          meta: {
            title: "Locations",
            key: "locations",
            requiresAuth: true,
          },
        },
        // Finance routes
        {
          path: "suppliers",
          name: "suppliers",
          component: () => import("@/pages/suppliers/List.vue"),
          meta: { title: "Suppliers", key: "supplier", requiresAuth: true },
        },
        {
          path: "add-supplier",
          name: "add-supplier",
          component: () => import("@/pages/suppliers/Add.vue"),
          meta: { title: "Add Supplier", requiresAuth: true },
        },
        {
          path: "edit-supplier/:id",
          name: "edit-supplier",
          component: () => import("@/pages/suppliers/Edit.vue"),
          meta: { title: "Edit Supplier", requiresAuth: true },
        },
        {
          path: "purchase-invoices",
          name: "purchase-invoices",
          component: () => import("@/pages/purchase-invoices/List.vue"),
          meta: { title: "Purchase Invoices", key: "purchase-invoice", requiresAuth: true },
        },
        {
          path: "add-purchase-invoice",
          name: "add-purchase-invoice",
          component: () => import("@/pages/purchase-invoices/Add.vue"),
          meta: { title: "Add Purchase Invoice", requiresAuth: true },
        },
        {
          path: "view-purchase-invoice/:id",
          name: "view-purchase-invoice",
          component: () => import("@/pages/purchase-invoices/View.vue"),
          meta: { title: "View Purchase Invoice", requiresAuth: true },
        },
        {
          path: "expenses",
          name: "expenses",
          component: () => import("@/pages/expenses/List.vue"),
          meta: { title: "Expenses", key: "expense", requiresAuth: true },
        },
        {
          path: "add-expense",
          name: "add-expense",
          component: () => import("@/pages/expenses/Add.vue"),
          meta: { title: "Add Expense", requiresAuth: true },
        },
        {
          path: "edit-expense/:id",
          name: "edit-expense",
          component: () => import("@/pages/expenses/Edit.vue"),
          meta: { title: "Edit Expense", requiresAuth: true },
        },
        {
          path: "expense-categories",
          name: "expense-categories",
          component: () => import("@/pages/expense-categories/List.vue"),
          meta: { title: "Expense Categories", requiresAuth: true },
        },
        {
          path: "profit-reports",
          name: "profit-reports",
          component: () => import("@/pages/profit-reports/index.vue"),
          meta: { title: "Profit Reports", requiresAuth: true },
        },
        {
          path: "doctor-commissions",
          name: "doctor-commissions",
          component: () => import("@/pages/commissions/DoctorCommissions.vue"),
          meta: { title: "Doctor Commissions", requiresAuth: true },
        },
        {
          path: "doctor-commissions/:uuid",
          name: "doctor-commission-details",
          component: () => import("@/pages/commissions/DoctorCommissionDetails.vue"),
          meta: { title: "Doctor Commission Details", requiresAuth: true },
        },
        {
          path: "researcher-commissions",
          name: "researcher-commissions",
          component: () => import("@/pages/commissions/ResearcherCommissions.vue"),
          meta: { title: "Researcher Commissions", requiresAuth: true },
        },
        {
          path: "researcher-commissions/:uuid",
          name: "researcher-commission-details",
          component: () => import("@/pages/commissions/ResearcherCommissionDetails.vue"),
          meta: { title: "Researcher Commission Details", requiresAuth: true },
        },
        {
          path: "researchers",
          name: "researchers",
          component: () => import("@/pages/researchers/List.vue"),
          meta: { title: "Researchers", requiresAuth: true },
        },
        {
          path: "add-researcher",
          name: "add-researcher",
          component: () => import("@/pages/researchers/Add.vue"),
          meta: { title: "Add Researcher", requiresAuth: true },
        },
        {
          path: "edit-researcher/:id",
          name: "edit-researcher",
          component: () => import("@/pages/researchers/Add.vue"),
          meta: { title: "Edit Researcher", requiresAuth: true },
        },
        {
          path: "view-researcher/:id",
          name: "view-researcher",
          component: () => import("@/pages/researchers/Add.vue"),
          meta: { title: "View Researcher", requiresAuth: true },
        },
        {
          path: "audit-logs",
          name: "audit-logs",
          component: () => import("@/pages/audit-logs/List.vue"),
          meta: { title: "Audit Logs", requiresAuth: true },
        },
        {
          path: "audit-logs/:id",
          name: "audit-log-details",
          component: () => import("@/pages/audit-logs/View.vue"),
          meta: { title: "Audit Log Details", requiresAuth: true },
        },
      ],
    },
    {
      path: "/",
      component: () => import("@/layout/ErrorLayout.vue"),
      children: [
        {
          path: "/404",
          name: "error-404",
          component: () => import("@/layout/ErrorLayout.vue"),
        },
        {
          path: "/500",
          name: "error-500",
          component: () => import("@/layout/ErrorLayout.vue"),
        },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      name: "error-404",
      component: () => import("@/layout/ErrorLayout.vue"),
    },
  ],
});

export default router;
